var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketPriorityHighIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140394",
    "data-name": "Rectangle 140394",
    width: 18,
    height: 18,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161987",
    "data-name": "Group 161987",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83209",
    "data-name": "Path 83209",
    d: "M24,12A12,12,0,1,1,12,0,12,12,0,0,1,24,12Z",
    transform: "translate(0)",
    fill: "#fcf4f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25",
    "data-name": "Mask Group 25",
    transform: "translate(2.458 3)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag_curved",
    transform: "translate(1.793 4.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83903",
    "data-name": "Path 83903",
    d: "M36.99,55.9V49.581A1.581,1.581,0,0,0,35.409,48H27.37a1.581,1.581,0,0,0-1.118.463L23.09,51.624a1.581,1.581,0,0,0,0,2.235l3.161,3.161a1.581,1.581,0,0,0,1.118.463h8.039A1.581,1.581,0,0,0,36.99,55.9Z",
    transform: "translate(-22.627 -48)",
    fill: "none",
    stroke: "#ff8484",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83902",
    "data-name": "Path 83902",
    d: "M66.371,85.186A1.186,1.186,0,1,1,65.186,84,1.186,1.186,0,0,1,66.371,85.186Z",
    transform: "translate(-59.913 -80.443)",
    fill: "#fff",
    stroke: "#ff8484",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketPriorityHighIcon);
export default __webpack_public_path__ + "static/media/ticket-priority-high-icon.3b061fc75d33536e82bf90b7ab4d7368.svg";
export { ForwardRef as ReactComponent };